import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 11,
		y: 6,
		width: 2,
		height: 2,
		fill: "white"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 11,
		y: 10,
		width: 2,
		height: 8,
		fill: "white"
	})]
});
export default SvgInfo;
